import * as yup from 'yup'

const validateSignUpForm = yup.object().shape({
  email: yup.string().required(' ').trim(),
  tab: yup.number(),
  password: yup
    .string()
    .min(8, 'Password should be a minimum of 8 characters.')
    .required(' ')
    .trim(),
  birthDate: yup
    .date()
    .required('Birthday cannot be blank')
    .typeError('Birthday must be a date in format mm/dd/yyyy')
    .test({
      name: 'is-at-least-17',
      test: function (value) {
        if (value && Date.parse(value)) {
          let bdate = new Date(value)
          let dateNow = new Date()
          let yearsDiff = dateNow.getFullYear() - bdate.getFullYear()

          if (yearsDiff >= 17) {
            return true
          } else {
            return this.createError({
              message: `You must be 17 years of age or older to sign up.`,
              path: 'birthDate',
            })
          }
        } else {
          return false
        }
      },
    }),
  gender: yup.string().required('Please select an option'),
  storeIds: yup
    .array()
    .required('Please select one or more options')
    .test({
      name: 'at-least-one-selected',

      test: function (value) {
        if (Array.isArray(value)) {
          if (value.length > 0) {
            return true
          }
        }
        return this.createError({
          message: `Please select one or more options`,
          path: 'storeIds',
        })
      },
    }),
  captchaResponseToken: yup.string().required('You must complete the captcha'),
})

const validateSignInForm = yup.object().shape({
  email_signin: yup.string().required(' ').trim(),
  tab: yup.number(),
  password_signin: yup.string().required(' ').trim(),
})

export { validateSignUpForm, validateSignInForm }
